import React, { useEffect, useState } from "react";
import { Button, Card, Col, ListGroup, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetFoodItemDetailsQuery } from "../slices/FoodItemSilce";
import { useSelector } from "react-redux";
import { formatAmount } from "../utils/commonUtils";

const FoodItemDetailsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { foodItemId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    data: foodItem,
    isLoading,
    error,
    refetch,
  } = useGetFoodItemDetailsQuery({
    id: foodItemId,
    token: userInfo.token,
  });

  useEffect(() => {
    if (!isLoading && !error) {
      refetch();
    }
  }, [isLoading, error, refetch]);

  const handleEditStatus = () => {
    navigate(`/editFoodItem/${foodItem._id}`, { state: { foodItem } });
  };

  const fromPage = location.state?.from;
  const showEditButton = location.state?.showEdit !== false;

  const handleBack = () => {
    if (fromPage === "allFoodItems") {
      navigate("/allFoods");
    } else {
      navigate("/viewMyOutlets");
    }
  };

  return (
    <>
      <Row className="mb-3">
        <Col>
          <Button variant="primary" onClick={handleBack}>
            Back
          </Button>
        </Col>
      </Row>

      <h6>Food Details</h6>

      <Row>
        <Col md={5}>
          <Card>
            <ListGroup>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Item Name:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.itemName}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Local Name:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.localName}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Category:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.itemCategory}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              {foodItem?.availableSizes?.length > 0 && (
                <>
                  <ListGroup.Item>
                    <strong>Available Sizes:</strong>
                  </ListGroup.Item>
                  {foodItem.availableSizes.map((size, index) => (
                    <ListGroup.Item key={index}>
                      <div style={{ padding: "0.25rem 0.5rem" }}>
                        <Row className="mb-1">
                          <Col xs={6}>
                            <strong>Size: {size.sizeName}</strong>
                          </Col>
                          <Col xs={6}>
                            Description:{" "}
                            <strong>{size.sizeDescription || "N/A"}</strong>
                            <br />
                            Price:{" "}
                            <strong> ₹{formatAmount(size.itemPrice)}</strong>
                            <br />
                            MakingCost:{" "}
                            <strong>₹{formatAmount(size.makingCost)}</strong>
                            <br />
                            DiscountPecent:{" "}
                            <strong>{size.discountPercent ?? 0} %</strong>
                            <br />
                            DiscountAmount: ₹
                            <strong>{formatAmount(size.discountAmount)}</strong>
                            <br />
                            Consumption Qty:{" "}
                            <strong> {size.consumptionQty}</strong>
                            <br />
                          </Col>
                        </Row>
                      </div>
                    </ListGroup.Item>
                  ))}
                </>
              )}

              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Available Quantity:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.itemQuantity}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Veg ?</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.isVeg ? "Yes" : "No"}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              {foodItem?.itemDescription && (
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <strong>Item Description:</strong>
                    </Col>
                    <Col>
                      <strong>{foodItem.itemDescription}</strong>
                    </Col>
                  </Row>
                </ListGroup.Item>
              )}

              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Currently Selling:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.currentlySelling ? "Yes" : "No"}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>

              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>GST Tax:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.gstTax ?? 0}%</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Added By:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.addedBy}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
      {showEditButton && (
        <Row style={{ marginTop: "1rem", marginBottom: "1rem" }}>
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <Button variant="primary" onClick={handleEditStatus}>
              Edit
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default FoodItemDetailsScreen;
